import { HEXtoRGBA } from "@/styles/helper";

export const colors = {
  bild: {
    vader500: "#212529",
    vader400: "#343A40",
    vader300: "#495057",
    vader200: "#868E96",
    vader100: "#CED4DA",
    vader50: "#E9ECEF",
    vader25: "#F8F9FA",
    vader0: "#FFFFFF",
    red600: "#AF0000",
    red500: "#DD0000",
    chewie500: "#00C373",
    background: "linear-gradient(135deg, #DD0000 0%, #551937 100%)",
  },
  spobi: {
    alfred100: "#efefef",
    alfred200: "#b5b5b5",
    alfred400: "#5e5e5e",
    alfred500: "#2e2e2e",
    spobiBlue: "#172f47",
    spobiRed: "#e2011b",
    spobiRedHover: "#be0a1f",
  },
  musikexpress: {
    yellow: "#FFEC41",
    lightYellow: "#FFF7AE",
    black: "#000000",
    nero: "#1E1E1E",
    darkGray: "#3E3E3E",
    lightGrey: "#F0F0F0",
    quartz: "#D3D3DE",
    white: "#FFFFFF",
    green: "#8BC78B",
    red: "#FA0000",
  },
  rollingstone: {
    primaryRed: "#D32531",
    secondaryRed: "#E60019",
    lightGrey: "#EFEFEF",
    white: "#FFFFFF",
    green: "#8BC78B",
    black: "#000000",
    black400: "#1D1D1D",
  },
  metalhammer: {
    primaryRed: "#FA0000",
    secondaryRed: "#FF9F9F",
    black: "#000000",
    black400: "#1D1D1D",
    lightGrey: "#DBDBDB",
    white: "#FFFFFF",
    green: "#8BC78B",
  },
  welt: {
    blue300: "#246EA7",
    blue500: "#064B71",
    blue600: "#003A5A",
    white: "#FFFFFF",
    black: "#000000",
  },
};

const defaultColors: ThemeInterface.IColors = {
  primary: "#213f59",
  primary100: "rgba(33, 63, 89, 0.6)",
  secondary: "#20b0a1",
  secondary100: "#43d8cf",
  tertiary: "#213f59",
  tertiary100: "rgba(33, 63, 89, 0.6)",
  success: "#68c200",
  checkmark: "#20b0a1",
  checkboxBorder: "#213f59",
  divider: "#20b0a1",
  error: "#f14938",
  button: "#213f59",
  button100: "#20b0a1",
  buttonText: "#ffffff",
  buttonSecondary: "#ffffff",
  buttonSecondaryBackground: "transparent",
  inputBackground: "#f2f2f2",
  borderGrey: "#e3e3e3",
  white: "#ffffff",
  black: "#000000",
  notification: "rgba(2, 10, 17, 0.9)",
  overlay: "rgba(2, 10, 17, 0.9)",
  fontText: "#333333",
  fontTextSemiLight: "#333333",
  fontTextLight: "#ffffff",
  defaultBackground: "#f2f2f2",
  sliderBackground: "#213f59",
  resultGlass: "#43d8cf",
  resultGlassBackground: "#20b0a1",
  resultGlassText: "#ffffff",
  resultBarText: "#ffffff",
  votingHorizontalLine: "#20b0a1",
  votingVoteColor: "#20b0a1",
  votingOptionColor: "#ffffff",
  votingPercentBubbleColor: HEXtoRGBA("#20b0a1", 0.8),
  votingPercentBubbleText: "#ffffff",
  votingOptionHeaderText: "#ffffff",
  votingVoteText: "#ffffff",
  votingOptionText: "#000000",
  votingOptionTextHover: "#20b0a1",
  linkText: "#213f59",
  npsOverlayBackground: "#ffffff",
  npsOverlayColor: "#1d1d1d",
  npsScoreBackground: "#eeeeee",
  npsSubtitleColor: "inherit",
  npsFeedbackText: "inherit",
  npsCloseBtn: "#1d1d1d",
  npsScoreBtn: "#ffffff",
  npsScoreBtnActive: "#213f59",
  npsScoreBtnHover: "#20b0a1",
  npsScoreBtnColor: "inherit",
  npsScoreBtnColorActive: "#ffffff",
  npsScoreBtnBorderColor: "#bdbdbd",
  npsInputColor: "inherit",
  npsInputBackground: "rgba(29, 29, 29, 0.04)",
  pollMultipleChoiceLabelColor: "#000000",
  pollMultipleChoiceLabelBackground: "rgba(249, 249, 248, 0.8)",
  pollAndQuizOptionBackground: "rgba(249, 249, 248, 0.8)",
  pollAndQuizOptionBackgroundModeResult: "#ffffff",
  pollOptionResultBarModeResult: "#213f59",
  pollOptionResultBarModeResultVote: "#20b0a1",
  pollOptionResultBarBackground: "#213f59",
  pollOptionResultBarBackgroundModeResult: "rgba(33, 63, 89, 0.6)",
  pollOptionResultBarBackgroundModeResultVote: "rgba(32, 176, 161, 0.6)",
  quizOptionResultBarBackground: "#213f59",
  quizOptionResultBarBackgroundCorrect: "rgba(104, 194, 0, 0.6)",
  quizOptionResultBarBackgroundWrong: "rgba(241, 73, 56, 0.6)",
  thumbsCount: "#1d1d1d",
  thumbsCountHidden: "#1d1d1d",
  thumbsButton: "#213f59", // tertiary
  thumbsButtonBackground: "#ffffff",
  thumbsButtonHover: "#20b0a1", // secondary
  thumbsButtonDisabled: "#e3e3e3",
  thumbsHeaderBackground: "linear-gradient(78deg, #213f59, #02233f)",
  thumbsBackground: "none",
  thumbsHeaderFont: "#ffffff",
  headerBackground: "linear-gradient(to bottom, #213f59, #02233f)",
  headerFont: "#ffffff",
  footerBackground: "#000000",
  footerFont: "#ffffff",
};

const defaultSpacing = {
  desktop: {
    s100: 5,
    s200: 10,
    s300: 15,
    s400: 18,
    s500: 20,
    s600: 23,
    s700: 25,
    s800: 30,
    s900: 40,
  },
  mobile: {
    s100: 2,
    s200: 5,
    s300: 5,
    s400: 7,
    s500: 10,
    s600: 11,
    s700: 12,
    s800: 25,
    s900: 15,
  },
};

const defaultBorders: ThemeInterface.IBorders = {
  answerTile: "1px",
  textOptionRadius: "0px",
  textOptionBorder: "0px",
  resultBarBorder: "0px",
  borderRadius: "0px",
  button: "1px",
  buttonRadius: "2px",
  buttonSecondary: "1px",
  checkbox: "1px",
  checkboxRadius: "0px",
  imageTile: "4px",
  imageTileHover: "4px",
  resultGlass: "5px",
  textarea: "1px",
  textareaRadius: "0px",
  thumbsButtonBorderRadius: "8px",
  votingHorizontalLine: "4px",
};

const otherDefaults: ThemeInterface.IOthers = {
  npsScoreBtnHeight: "24px",
  npsScoreBtnWidth: "24px",
};

const Variants: Record<string, IVariants> = {
  default: {
    colors: defaultColors,
    spacing: defaultSpacing,
    borders: defaultBorders,
    others: otherDefaults,
  },

  aubi: {
    colors: {
      ...defaultColors,
      primary: "#333333",
      secondary: "#f00000",
      secondary100: HEXtoRGBA("#f00000", 0.6),
      tertiary: "#333333",
      tertiary100: HEXtoRGBA("#333333", 0.6),
      button: "#333333",
      button100: "#f00000",
      success: "#52AF4F",
      checkmark: "#f00000",
      divider: "#f00000",
      error: "#F00000",
      sliderBackground: "#999999",
      resultGlass: "#f00000",
      resultGlassBackground: "#000000",
      resultGlassBorder: "#ffffff",
      votingHorizontalLine: "#f00000",
      votingVoteColor: "#f00000",
      votingOptionTextHover: "#f00000",
      votingPercentBubbleColor: HEXtoRGBA("#f00000", 0.8),
      linkText: "#333333",
      npsScoreBtn: "#ffffff",
      npsScoreBtnActive: "#f00000",
      npsScoreBtnHover: "#f00000",
      npsScoreBtnColor: "inherit",
      npsScoreBtnColorActive: "#ffffff",
      npsScoreBtnBorderColor: "#bdbdbd",
      pollOptionResultBarModeResult: "#333333", // tertiary
      pollOptionResultBarModeResultVote: "#f00000", // secondary
      pollOptionResultBarBackground: "#333333", // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA("#333333", 0.6), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA("#f00000", 0.6), // secondary100
      thumbsButton: "#333333", // tertiary
      thumbsButtonHover: "#f00000", // secondary
      thumbsHeaderBackground: "linear-gradient(78deg, #555555, #333333)",
      headerBackground: "linear-gradient(to bottom, #444444, #333333)",
    },
    spacing: defaultSpacing,
    borders: { ...defaultBorders, resultGlass: "0px" },
    others: otherDefaults,
  },

  cobi: {
    colors: {
      ...defaultColors,
      primary: "#000000",
      secondary: "#DC241C",
      secondary100: HEXtoRGBA("#DC241C", 0.6),
      tertiary: "#000000",
      tertiary100: HEXtoRGBA("#000000", 0.6),
      button: "#000000",
      button100: "#DC241C",
      success: "#52AF4F",
      checkmark: "#DC241C",
      divider: "#DC241C",
      error: "#DC241C",
      sliderBackground: "#DEE1E6",
      resultGlass: "#DC241C",
      resultGlassBackground: "#000000",
      resultGlassBorder: "#ffffff",
      votingHorizontalLine: "#DC241C",
      votingVoteColor: "#DC241C",
      votingOptionTextHover: "#DC241C",
      votingPercentBubbleColor: HEXtoRGBA("#DC241C", 0.8),
      linkText: "#DC241C",
      npsScoreBtn: "#ffffff",
      npsScoreBtnActive: "#DC241C",
      npsScoreBtnHover: "#DC241C",
      npsScoreBtnColor: "inherit",
      npsScoreBtnColorActive: "#ffffff",
      npsScoreBtnBorderColor: "#bdbdbd",
      pollOptionResultBarModeResult: "#000000", // tertiary
      pollOptionResultBarModeResultVote: "#DC241C", // secondary
      pollOptionResultBarBackground: "#000000", // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA("#000000", 0.6), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA("#DC241C", 0.6), // secondary100
      thumbsButton: "#000000", // tertiary
      thumbsButtonHover: "#DC241C", // secondary
      thumbsHeaderBackground: "#DC241C",
      headerBackground: "#DC241C",
    },
    spacing: defaultSpacing,
    borders: { ...defaultBorders, resultGlass: "0px" },
    others: otherDefaults,
  },

  spobi: {
    colors: {
      ...defaultColors,
      primary: colors.spobi.alfred500,
      secondary: colors.spobi.spobiRed,
      secondary100: HEXtoRGBA(colors.spobi.spobiRed, 0.6),
      tertiary: colors.spobi.alfred500,
      tertiary100: HEXtoRGBA(colors.spobi.alfred500, 0.6),
      button: colors.spobi.spobiRed,
      button100: colors.spobi.spobiRedHover,
      success: "#52AF4F",
      checkmark: colors.spobi.spobiRed,
      divider: colors.spobi.spobiRed,
      error: colors.spobi.spobiRed,
      sliderBackground: colors.spobi.alfred200,
      resultGlass: colors.spobi.spobiRed,
      resultGlassBackground: "#000000",
      resultGlassBorder: "#ffffff",
      votingHorizontalLine: colors.spobi.spobiRed,
      votingVoteColor: colors.spobi.spobiRed,
      votingOptionTextHover: colors.spobi.spobiRed,
      votingPercentBubbleColor: HEXtoRGBA(colors.spobi.spobiRed, 0.8),
      linkText: colors.spobi.alfred500,
      npsScoreBtn: "#ffffff",
      npsScoreBtnActive: colors.spobi.spobiRed,
      npsScoreBtnHover: colors.spobi.spobiRed,
      npsScoreBtnColor: "inherit",
      npsScoreBtnColorActive: "#ffffff",
      npsScoreBtnBorderColor: colors.spobi.alfred200,
      pollOptionResultBarModeResult: colors.spobi.alfred500, // tertiary
      pollOptionResultBarModeResultVote: colors.spobi.spobiRed, // secondary
      pollOptionResultBarBackground: colors.spobi.alfred500, // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA(
        colors.spobi.alfred500,
        0.6
      ), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA(
        colors.spobi.spobiRed,
        0.6
      ), // secondary100
      thumbsButton: colors.spobi.alfred500, // tertiary
      thumbsButtonHover: colors.spobi.spobiRed, // secondary
      thumbsHeaderBackground: colors.spobi.spobiRed,
      headerBackground: colors.spobi.spobiRed,
    },
    spacing: defaultSpacing,
    borders: defaultBorders,
    others: otherDefaults,
  },

  bild: {
    colors: {
      ...defaultColors,
      primary: "#DD0000",
      secondary: "#212529",
      secondary100: "#444648",
      tertiary: "#D2D2D2",
      tertiary100: "#E9ECEF",
      success: "#00C373",
      checkmark: "#00C373",
      checkboxBorder: "#495057",
      divider: "#ffffff",
      error: "#dd0000",
      button: "#dd0000",
      button100: "#a80000",
      buttonText: "#ffffff",
      buttonSecondary: "#ffffff",
      borderGrey: "#CED4DA",
      fontText: "#000000",
      fontTextSemiLight: "#212529",
      defaultBackground: colors.bild.background,
      thumbsBackground: colors.bild.background,
      sliderBackground: "transparent",
      resultGlass: "#212529",
      resultGlassBackground: "#212529",
      inputColor: "#172F47",
      votingHorizontalLine: "rgba(255, 255, 255, 0.5)",
      votingVoteColor: "#AF0000",
      votingOptionTextHover: "#AF0000",
      votingPercentBubbleColor: "#AF0000",
      linkText: "#DD0000",
      npsOverlayBackground: colors.bild.vader400,
      npsOverlayColor: colors.bild.vader25,
      npsScoreBackground: "transparent",
      npsSubtitleColor: colors.bild.vader100,
      npsFeedbackText: colors.bild.vader100,
      npsScoreBtn: "transparent",
      npsScoreBtnActive: "#ffffff",
      npsCloseBtn: "#ffffff",
      npsScoreBtnColor: "#ffffff",
      npsScoreBtnColorActive: colors.bild.red500,
      npsScoreBtnBorderColor: "#8E9196",
      npsScoreBtnHover: "#ffffff",
      npsInputColor: "#000000",
      npsInputBackground: "#ffffff",
      pollAndQuizOptionBackgroundModeResult: "#ffffff",
      pollAndQuizOptionBackground: "#ffffff",
      pollMultipleChoiceLabelColor: "#ffffff",
      pollMultipleChoiceLabelBackground: "#000000",
      pollOptionResultBarModeResult: "#868E96",
      pollOptionResultBarModeResultVote: "#AF0000",
      pollOptionResultBarBackground: "#D2D2D2",
      pollOptionResultBarBackgroundModeResult: "#495057",
      pollOptionResultBarBackgroundModeResultVote: "#495057",
      quizOptionResultBarBackground: "#D2D2D2",
      quizOptionResultBarBackgroundCorrect: "rgba(0, 195, 115, 0.60)",
      quizOptionResultBarBackgroundWrong: "rgba(221, 0, 0, 0.6)",
      thumbsButton: colors.bild.vader500,
      thumbsButtonDisabled: colors.bild.vader300,
      thumbsButtonHover: "#DD0000", // primary
      thumbsCountHidden: "#ffffff",
      thumbsHeaderBackground: "none",
      headerBackground: "none",
      footerBackground: "none",
      footerFont: "#ffffff",
      overlay: HEXtoRGBA(colors.bild.vader500, 0.75),
    },
    spacing: defaultSpacing,
    borders: {
      ...defaultBorders,
      interaction: "8px",
      borderRadius: "8px",
      button: "0px",
      buttonSecondary: "2px",
      buttonRadius: "8px",
      checkbox: "2px",
      checkboxRadius: "4px",
      answerTile: "0px",
      textOptionRadius: "8px",
      votingHorizontalLine: "2px",
      textarea: "0px",
      textareaRadius: "8px",
    },
    others: Object.assign({}, otherDefaults, {
      npsScoreBtnHeight: "33px",
    }),
  },

  bild_fitbook: {
    colors: {
      ...defaultColors,
      primary: "#333333",
      secondary: "#43d8cf",
      secondary100: HEXtoRGBA("#43d8cf", 0.6),
      tertiary: "#333333",
      tertiary100: HEXtoRGBA("#333333", 0.6),
      checkmark: "#43d8cf",
      divider: "#43d8cf",
      button: "#333333",
      button100: "#43d8cf",
      resultGlassBackground: "#43d8cf",
      sliderBackground: "#333333",
      linkText: "#333333",
      pollOptionResultBarModeResult: "#333333", // tertiary
      pollOptionResultBarModeResultVote: "#43d8cf", // secondary
      pollOptionResultBarBackground: "#333333", // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA("#333333", 0.6), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA("#43d8cf", 0.6), // secondary100
      thumbsButton: "#333333", // tertiary
      thumbsButtonHover: "#43d8cf", // secondary
      thumbsHeaderBackground: "linear-gradient(78deg, #555555, #333333)",
      headerBackground: "linear-gradient(to bottom, #444444, #333333)",
    },
    spacing: defaultSpacing,
    borders: defaultBorders,
    others: otherDefaults,
  },

  bild_stylebook: {
    colors: {
      ...defaultColors,
      primary: "#333333",
      secondary: "#ff00c9",
      secondary100: HEXtoRGBA("#ff00c9", 0.6),
      tertiary: "#333333",
      tertiary100: HEXtoRGBA("#333333", 0.6),
      checkmark: "#ff00c9",
      divider: "#ff00c9",
      button: "#333333",
      button100: "#ff00c9",
      sliderBackground: "#333333",
      resultGlass: "#ff00c9",
      resultGlassBackground: "#ff00c9",
      linkText: "#333333",
      pollOptionResultBarModeResult: "#333333", // tertiary
      pollOptionResultBarModeResultVote: "#ff00c9", // secondary
      pollOptionResultBarBackground: "#333333", // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA("#333333", 0.6), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA("#ff00c9", 0.6), // secondary100
      thumbsButton: "#333333", // tertiary
      thumbsButtonHover: "#ff00c9", // secondary
      thumbsHeaderBackground: "linear-gradient(78deg, #555555, #333333)",
      headerBackground: "linear-gradient(to bottom, #444444, #333333)",
    },
    spacing: defaultSpacing,
    borders: defaultBorders,
    others: otherDefaults,
  },

  bild_techbook: {
    colors: {
      ...defaultColors,
      primary: "#333333",
      secondary: "#00ccff",
      secondary100: HEXtoRGBA("#00ccff", 0.6),
      tertiary: "#333333",
      tertiary100: HEXtoRGBA("#333333", 0.6),
      checkmark: "#00ccff",
      divider: "#00ccff",
      button: "#333333",
      button100: "#00ccff",
      sliderBackground: "#333333",
      resultGlass: "#00ccff",
      resultGlassBackground: "#00ccff",
      linkText: "#333333",
      pollOptionResultBarModeResult: "#333333", // tertiary
      pollOptionResultBarModeResultVote: "#00ccff", // secondary
      pollOptionResultBarBackground: "#333333", // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA("#333333", 0.6), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA("#00ccff", 0.6), // secondary100
      thumbsButton: "#333333", // tertiary
      thumbsButtonHover: "#00ccff", // secondary
      thumbsHeaderBackground: "linear-gradient(78deg, #555555, #333333)",
      headerBackground: "linear-gradient(to bottom, #444444, #333333)",
    },
    spacing: defaultSpacing,
    borders: defaultBorders,
    others: otherDefaults,
  },

  bild_travelbook: {
    colors: {
      ...defaultColors,
      primary: "#333333",
      secondary: "#20b0a1",
      secondary100: HEXtoRGBA("#20b0a1", 0.6),
      tertiary: "#333333",
      tertiary100: HEXtoRGBA("#333333", 0.6),
      checkmark: "#20b0a1",
      divider: "#20b0a1",
      button: "#333333",
      button100: "#20b0a1",
      sliderBackground: "#333333",
      resultGlass: "#20b0a1",
      resultGlassBackground: "#20b0a1",
      linkText: "#333333",
      pollOptionResultBarModeResult: "#333333", // tertiary
      pollOptionResultBarModeResultVote: "#20b0a1", // secondary
      pollOptionResultBarBackground: "#333333", // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA("#333333", 0.6), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA("#20b0a1", 0.6), // secondary100
      thumbsButton: "#333333", // tertiary
      thumbsButtonHover: "#20b0a1", // secondary
      thumbsHeaderBackground: "linear-gradient(78deg, #555555, #333333)",
      headerBackground: "linear-gradient(to bottom, #444444, #333333)",
    },
    spacing: defaultSpacing,
    borders: defaultBorders,
    others: otherDefaults,
  },

  bild_myhomebook: {
    colors: {
      ...defaultColors,
      primary: "#333333",
      secondary: "#008282",
      secondary100: HEXtoRGBA("#008282", 0.6),
      tertiary: "#333333",
      tertiary100: HEXtoRGBA("#333333", 0.6),
      checkmark: "#008282",
      divider: "#008282",
      button: "#333333",
      button100: "#008282",
      sliderBackground: "#333333",
      resultGlass: "#008282",
      resultGlassBackground: "#008282",
      linkText: "#333333",
      pollOptionResultBarModeResult: "#333333", // tertiary
      pollOptionResultBarModeResultVote: "#008282", // secondary
      pollOptionResultBarBackground: "#333333", // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA("#333333", 0.6), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA("#008282", 0.6), // secondary100
      thumbsButton: "#333333", // tertiary
      thumbsButtonHover: "#008282", // secondary
      thumbsHeaderBackground: "linear-gradient(78deg, #555555, #333333)",
      headerBackground: "linear-gradient(to bottom, #444444, #333333)",
    },
    spacing: defaultSpacing,
    borders: defaultBorders,
    others: otherDefaults,
  },

  welt: {
    colors: {
      ...defaultColors,
      primary: "#213f59",
      secondary: "#f18825",
      secondary100: "rgba(241, 136, 37, 0.6)",
      tertiary: colors.welt.blue600,
      tertiary100: "rgba(0, 58, 90, 0.6)",
      success: "#64964b",
      checkmark: "#f18825",
      checkboxBorder: "rgba(29, 29, 29, 0.7)",
      divider: "#f18825",
      error: "#b71336",
      button: "#f18825",
      button100: "#f18825",
      buttonSecondary: "#ffffff",
      inputBackground: "#edece8",
      notification: "rgba(0, 58, 90, 0.9)",
      fontText: "#1d1d1d",
      fontTextSemiLight: "#1d1d1d",
      defaultBackground: "#edece8",
      sliderBackground: "#dcdde0",
      resultGlass: "#f18825",
      resultGlassBackground: "#f18825",
      votingBackground: "#383e46",
      votingHorizontalLine: "#f18825",
      votingVoteColor: "#f18825",
      votingOptionTextHover: "#f18825",
      votingPercentBubbleColor: HEXtoRGBA("#f18825", 0.8),
      linkText: "#213f59",
      npsScoreBtnActive: colors.welt.blue600,
      npsScoreBtnHover: colors.welt.blue500,
      pollMultipleChoiceLabelColor: "#1D1D1D",
      pollOptionResultBarModeResult: colors.welt.blue600, // tertiary
      pollOptionResultBarModeResultVote: "#f18825", // secondary
      pollOptionResultBarBackground: colors.welt.blue600, // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA(
        colors.welt.blue600,
        0.6
      ), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA("#f18825", 0.6), // secondary100
      quizOptionResultBarBackground: colors.welt.blue600,
      quizOptionResultBarBackgroundCorrect: "rgba(100, 150, 75, 0.6)",
      quizOptionResultBarBackgroundWrong: "rgba(183, 19, 54, 0.6)",
      thumbsButton: colors.welt.blue600, // tertiary
      thumbsButtonHover: "#f18825", // secondary
      thumbsHeaderBackground: "#edece8",
      thumbsHeaderFont: "#1d1d1d",
      headerBackground: "#edece8",
      headerFont: "#1d1d1d",
      footerBackground: "none",
      footerFont: "#000000",
    },
    spacing: defaultSpacing,
    borders: {
      ...defaultBorders,
      borderRadius: "3px",
      buttonRadius: "3px",
      answerTile: "1px",
    },
    others: otherDefaults,
  },

  welt_contrast: {
    colors: {
      ...defaultColors,
      primary: colors.welt.blue600,
      secondary: colors.welt.blue600,
      secondary100: "rgba(241, 136, 37, 0.6)",
      tertiary: colors.welt.blue600,
      tertiary100: "rgba(0, 58, 90, 0.6)",
      success: "#64964b",
      checkmark: "#f18825",
      checkboxBorder: "rgba(29, 29, 29, 0.7)",
      divider: colors.welt.blue600,
      error: "#b71336",
      button: colors.welt.blue600,
      button100: colors.welt.blue600,
      buttonSecondary: "#ffffff",
      inputBackground: "#edece8",
      notification: "rgba(0, 58, 90, 0.9)",
      fontText: "#1d1d1d",
      fontTextSemiLight: "#1d1d1d",
      defaultBackground: colors.welt.blue600,
      sliderBackground: colors.welt.white,
      resultGlass: colors.welt.blue600,
      resultGlassBackground: colors.welt.blue600,
      votingBackground: "#383e46",
      votingHorizontalLine: "#f18825",
      votingVoteColor: "#f18825",
      votingOptionTextHover: "#f18825",
      votingPercentBubbleColor: HEXtoRGBA("#f18825", 0.8),
      linkText: "#213f59",
      npsScoreBtnActive: colors.welt.blue600,
      npsScoreBtnHover: colors.welt.blue500,
      resultBarText: colors.welt.blue600,
      pollMultipleChoiceLabelColor: "#1D1D1D",
      pollOptionResultBarModeResult: colors.welt.blue600, // tertiary
      pollOptionResultBarModeResultVote: colors.welt.blue600, // secondary
      pollOptionResultBarBackground: colors.welt.blue600, // tertiary
      pollOptionResultBarBackgroundModeResult: colors.welt.white,
      pollOptionResultBarBackgroundModeResultVote: colors.welt.white,
      pollAndQuizOptionBackground: colors.welt.white,
      pollAndQuizOptionBackgroundModeResult: colors.welt.white,
      quizOptionResultBarBackground: colors.welt.blue600,
      quizOptionResultBarBackgroundCorrect: "rgba(100, 150, 75, 0.6)",
      quizOptionResultBarBackgroundWrong: "rgba(183, 19, 54, 0.6)",
      thumbsButton: colors.welt.blue600,
      thumbsButtonBackground: colors.welt.white,
      thumbsButtonBackgroundHover: colors.welt.blue600,
      thumbsButtonDisabled: colors.welt.blue600,
      thumbsButtonHover: colors.welt.white,
      thumbsCount: colors.welt.white,
      thumbsHeaderBackground: colors.welt.blue600,
      thumbsHeaderFont: colors.welt.white,
      headerBackground: colors.welt.blue600,
      headerFont: colors.welt.white,
      footerBackground: "none",
      footerFont: colors.welt.white,
    },
    spacing: defaultSpacing,
    borders: {
      ...defaultBorders,
      thumbsButtonBorderRadius: "0px",
      borderRadius: "3px",
      buttonRadius: "3px",
      answerTile: "1px",
      textOptionBorder: "1px",
      resultBarBorder: "1px",
    },
    others: otherDefaults,
  },

  icon: {
    colors: {
      ...defaultColors,
      primary: "#213f59",
      secondary: "#99B7AB",
      secondary100: "rgba(241, 136, 37, 0.6)",
      tertiary: colors.welt.blue600,
      tertiary100: "rgba(0, 58, 90, 0.6)",
      success: "#64964b",
      checkmark: "#f18825",
      checkboxBorder: "rgba(29, 29, 29, 0.7)",
      divider: "#99B7AB",
      error: "#b71336",
      button: "#f18825",
      button100: "#f18825",
      inputBackground: "#edece8",
      notification: "#99B7AB",
      fontText: "#1d1d1d",
      defaultBackground: "#ffffff",
      sliderBackground: "#dcdde0",
      resultGlass: "#f18825",
      resultGlassBackground: "#f18825",
      votingBackground: "#383e46",
      votingVoteColor: "#99B7AB",
      votingOptionTextHover: "#99B7AB",
      votingPercentBubbleColor: HEXtoRGBA("#99B7AB", 0.8),
      votingHorizontalLine: "#99B7AB",
      linkText: "#213f59",
      pollMultipleChoiceLabelColor: "#1D1D1D",
      pollOptionResultBarModeResult: colors.welt.blue600, // tertiary
      pollOptionResultBarModeResultVote: "#99B7AB", // secondary
      pollOptionResultBarBackground: colors.welt.blue600, // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA(
        colors.welt.blue600,
        0.6
      ), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA("#99B7AB", 0.6), // secondary100
      quizOptionResultBarBackground: colors.welt.blue600,
      quizOptionResultBarBackgroundCorrect: "rgba(100, 150, 75, 0.6)",
      quizOptionResultBarBackgroundWrong: "rgba(183, 19, 54, 0.6)",
      thumbsButton: colors.welt.blue600, // tertiary
      thumbsButtonHover: "#99B7AB", // secondary
      thumbsHeaderBackground: "#ffffff",
      thumbsHeaderFont: "#1d1d1d",
      headerBackground: "#ffffff",
      headerFont: "#1d1d1d",
      footerBackground: "none",
      footerFont: "#000000",
    },
    spacing: defaultSpacing,
    borders: {
      ...defaultBorders,
      borderRadius: "3px",
      buttonRadius: "3px",
      answerTile: "1px",
    },
    others: otherDefaults,
  },
  mediapioneer: {
    colors: {
      ...defaultColors,
      primary: "#6622C3",
      primary100: "rgba(102, 34, 195, 0.6)",
      secondary: "#A3065E",
      secondary100: "#DA9BBF",
      tertiary: "#6622C3",
      tertiary100: "rgba(102, 34, 195, 0.6)",
      success: "#68c200",
      checkmark: "#A3065E",
      checkboxBorder: "#6622C3",
      divider: "#A3065E",
      error: "#f14938",
      button: "#6622C3",
      button100: "#A3065E",
      buttonSecondary: "#6622C3",
      buttonSecondaryBackground: "#ffffff",
      inputBackground: "#f2f2f2",
      borderGrey: "#e3e3e3",
      white: "#ffffff",
      black: "#1D1D1D",
      notification: "rgba(2, 10, 17, 0.9)",
      fontText: "#333333",
      fontTextSemiLight: "#333333",
      fontTextLight: "#ffffff",
      defaultBackground: "#F9F6FC",
      sliderBackground: "#F9F6FC",
      resultGlass: "#DA9BBF",
      resultGlassBackground: "#A3065E",
      votingHorizontalLine: "#6622C3",
      votingVoteColor: "#6622C3",
      votingOptionTextHover: "#6622C3",
      votingPercentBubbleColor: HEXtoRGBA("#A3065E", 0.8),
      votingOptionHeaderText: "#1F1F1F",
      linkText: "#6622C3",
      npsScoreBtn: "#ffffff",
      npsScoreBtnActive: "#6622C3",
      npsScoreBtnHover: "#6622C3",
      npsScoreBtnColor: "inherit",
      npsScoreBtnColorActive: "#ffffff",
      npsScoreBtnBorderColor: "#bdbdbd",
      pollMultipleChoiceLabelColor: "#333333",
      pollOptionResultBarModeResult: "#6622C3", // tertiary
      pollOptionResultBarModeResultVote: "#A3065E", // secondary
      pollOptionResultBarBackground: "#6622C3", // tertiary
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA("#6622C3", 0.6), // tertiary100
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA("#A3065E", 0.6), // secondary100
      quizOptionResultBarBackground: "#6622C3",
      quizOptionResultBarBackgroundCorrect: "rgba(104, 194, 0, 0.6)",
      quizOptionResultBarBackgroundWrong: "rgba(241, 73, 56, 0.6)",
      thumbsButton: "#6622C3", // tertiary
      thumbsButtonHover: "#A3065E", // secondary
      thumbsHeaderBackground:
        "linear-gradient(270deg, #97205E 0%, #5D2DBC 100%)",
      headerBackground: "linear-gradient(270deg, #97205E 0%, #5D2DBC 100%)",
    },
    spacing: defaultSpacing,
    borders: defaultBorders,
    others: otherDefaults,
  },
  musikexpress: {
    colors: {
      ...defaultColors,
      button: colors.musikexpress.yellow,
      button100: HEXtoRGBA(colors.musikexpress.yellow, 0.6),
      buttonSecondary: colors.musikexpress.black,
      buttonText: colors.musikexpress.black,
      checkboxBorder: colors.musikexpress.yellow,
      checkmark: colors.musikexpress.yellow,
      defaultBackground: colors.musikexpress.white,
      divider: colors.musikexpress.yellow,
      error: colors.musikexpress.red,
      fontText: colors.musikexpress.black,
      fontTextSemiLight: colors.musikexpress.nero,
      headerBackground: colors.musikexpress.yellow,
      headerFont: colors.musikexpress.black,
      linkText: colors.musikexpress.black,
      npsScoreBackground: colors.musikexpress.lightGrey,
      npsScoreBtnActive: colors.musikexpress.black,
      npsScoreBtnBorderColor: colors.musikexpress.quartz,
      npsScoreBtnColorActive: colors.musikexpress.yellow,
      npsScoreBtnHover: colors.musikexpress.black,
      overlay: HEXtoRGBA(colors.musikexpress.black, 0.65),
      pollMultipleChoiceLabelBackground: colors.musikexpress.lightGrey,
      pollOptionResultBarBackground: colors.musikexpress.black,
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA(
        colors.musikexpress.black,
        0.4
      ),
      pollOptionResultBarBackgroundModeResultVote:
        colors.musikexpress.lightYellow,
      pollOptionResultBarModeResult: colors.musikexpress.black,
      pollOptionResultBarModeResultVote: colors.musikexpress.yellow,
      primary: colors.musikexpress.black,
      primary100: HEXtoRGBA(colors.musikexpress.black, 0.6),
      quizOptionResultBarBackground: colors.musikexpress.black,
      quizOptionResultBarBackgroundCorrect: HEXtoRGBA(
        colors.musikexpress.green,
        0.4
      ),
      quizOptionResultBarBackgroundWrong: HEXtoRGBA(
        colors.musikexpress.red,
        0.4
      ),
      resultBarText: colors.musikexpress.black,
      resultGlass: colors.musikexpress.yellow,
      resultGlassBackground: colors.musikexpress.lightYellow,
      resultGlassBorder: colors.musikexpress.white,
      resultGlassText: colors.musikexpress.black,
      secondary: colors.musikexpress.yellow,
      secondary100: HEXtoRGBA(colors.musikexpress.yellow, 0.6),
      sliderBackground: colors.musikexpress.lightGrey,
      success: colors.musikexpress.green,
      tertiary: colors.musikexpress.yellow,
      tertiary100: colors.musikexpress.yellow,
      thumbsBackground: "none",
      thumbsButton: colors.musikexpress.white,
      thumbsButtonBackground: colors.musikexpress.black,
      thumbsButtonHover: colors.musikexpress.yellow,
      thumbsCount: colors.musikexpress.white,
      thumbsCountHidden: colors.musikexpress.black,
      thumbsHeaderBackground: colors.musikexpress.yellow,
      votingHorizontalLine: colors.musikexpress.black,
      votingOptionColor: colors.musikexpress.black,
      votingOptionHeaderText: colors.musikexpress.black,
      votingOptionText: colors.musikexpress.white,
      votingOptionTextHover: colors.musikexpress.yellow,
      votingPercentBubbleColor: HEXtoRGBA(colors.musikexpress.yellow, 0.8),
      votingPercentBubbleText: colors.musikexpress.black,
      votingVoteColor: colors.musikexpress.yellow,
      votingVoteText: colors.musikexpress.black,
    },
    spacing: defaultSpacing,
    borders: { ...defaultBorders, resultGlass: "0px" },
    others: otherDefaults,
  },
  rollingstone: {
    colors: {
      ...defaultColors,
      button: colors.rollingstone.primaryRed,
      button100: HEXtoRGBA(colors.rollingstone.primaryRed, 0.6),
      buttonSecondary: colors.rollingstone.black,
      buttonText: colors.rollingstone.white,
      checkboxBorder: colors.rollingstone.primaryRed,
      checkmark: colors.rollingstone.primaryRed,
      defaultBackground: colors.rollingstone.lightGrey,
      divider: colors.rollingstone.primaryRed,
      error: colors.rollingstone.primaryRed,
      fontText: colors.rollingstone.black,
      fontTextSemiLight: colors.rollingstone.black400,
      headerBackground: colors.rollingstone.lightGrey,
      headerFont: colors.rollingstone.black,
      linkText: colors.rollingstone.primaryRed,
      npsScoreBackground: colors.rollingstone.lightGrey,
      npsScoreBtnActive: colors.rollingstone.primaryRed,
      npsScoreBtnBorderColor: colors.rollingstone.lightGrey,
      npsScoreBtnColorActive: colors.rollingstone.white,
      npsScoreBtnHover: colors.rollingstone.primaryRed,
      overlay: HEXtoRGBA(colors.rollingstone.black, 0.65),
      pollMultipleChoiceLabelBackground: colors.rollingstone.lightGrey,
      pollAndQuizOptionBackground: colors.rollingstone.lightGrey,
      pollAndQuizOptionBackgroundModeResult: colors.rollingstone.lightGrey,
      pollOptionResultBarBackground: colors.rollingstone.black,
      pollOptionResultBarBackgroundModeResult: HEXtoRGBA(
        colors.rollingstone.secondaryRed,
        0.2
      ),
      pollOptionResultBarBackgroundModeResultVote: HEXtoRGBA(
        colors.rollingstone.secondaryRed,
        0.2
      ),
      pollOptionResultBarModeResult: colors.rollingstone.primaryRed,
      pollOptionResultBarModeResultVote: colors.rollingstone.primaryRed,

      primary: colors.rollingstone.primaryRed,
      primary100: HEXtoRGBA(colors.rollingstone.black, 0.6),
      quizOptionResultBarBackground: colors.rollingstone.black,
      quizOptionResultBarBackgroundCorrect: HEXtoRGBA(
        colors.rollingstone.green,
        0.4
      ),
      quizOptionResultBarBackgroundWrong: HEXtoRGBA(
        colors.rollingstone.primaryRed,
        0.4
      ),
      resultBarText: colors.rollingstone.white,
      resultGlass: colors.rollingstone.primaryRed,
      resultGlassBackground: colors.rollingstone.secondaryRed,
      resultGlassBorder: HEXtoRGBA(colors.rollingstone.secondaryRed, 0.2),
      resultGlassText: colors.rollingstone.white,
      secondary: colors.rollingstone.primaryRed,
      secondary100: HEXtoRGBA(colors.rollingstone.primaryRed, 0.6),
      sliderBackground: colors.rollingstone.white,
      success: colors.rollingstone.green,
      tertiary: colors.rollingstone.primaryRed,
      tertiary100: colors.rollingstone.primaryRed,
      thumbsBackground: "none",
      thumbsButton: colors.rollingstone.black,
      thumbsButtonBackground: colors.rollingstone.white,
      thumbsButtonHover: colors.rollingstone.primaryRed,
      thumbsCount: colors.rollingstone.black,
      thumbsCountHidden: colors.rollingstone.black,
      thumbsHeaderBackground: colors.rollingstone.primaryRed,
      thumbsHeaderFont: colors.rollingstone.white,
      votingHorizontalLine: colors.rollingstone.black,
      votingOptionColor: colors.rollingstone.black,
      votingOptionHeaderText: colors.rollingstone.black,
      votingOptionText: colors.rollingstone.white,
      votingOptionTextHover: colors.rollingstone.primaryRed,
      votingPercentBubbleColor: HEXtoRGBA(colors.rollingstone.primaryRed, 0.8),
      votingPercentBubbleText: colors.rollingstone.black,
      votingVoteColor: colors.rollingstone.primaryRed,
      votingVoteText: colors.rollingstone.black,
      inputColor: colors.rollingstone.black400,
    },
    spacing: defaultSpacing,
    borders: { ...defaultBorders, resultGlass: "0px", answerTile: "0px" },
    others: otherDefaults,
  },
  metalhammer: {
    colors: {
      ...defaultColors,
      button: colors.metalhammer.primaryRed,
      button100: HEXtoRGBA(colors.metalhammer.primaryRed, 0.6),
      buttonSecondary: colors.metalhammer.black,
      buttonText: colors.metalhammer.white,
      checkboxBorder: colors.metalhammer.primaryRed,
      checkmark: colors.metalhammer.primaryRed,
      defaultBackground: colors.metalhammer.white,
      divider: colors.metalhammer.primaryRed,
      error: colors.metalhammer.primaryRed,
      fontText: colors.metalhammer.black,
      fontTextSemiLight: colors.metalhammer.black400,
      headerBackground: colors.metalhammer.primaryRed,
      headerFont: colors.metalhammer.white,
      footerFont: colors.metalhammer.white,
      footerBackground: colors.metalhammer.primaryRed,
      linkText: colors.metalhammer.primaryRed,
      npsOverlayBackground: colors.metalhammer.black,
      npsOverlayColor: colors.metalhammer.white,
      npsCloseBtn: colors.metalhammer.white,
      npsScoreBackground: colors.metalhammer.white,
      npsScoreBtnActive: colors.metalhammer.black,
      npsScoreBtnColor: colors.metalhammer.black,
      npsScoreBtnBorderColor: colors.metalhammer.lightGrey,
      npsScoreBtnColorActive: colors.metalhammer.white,
      npsScoreBtnHover: colors.metalhammer.black,
      npsSubtitleColor: colors.metalhammer.black,
      npsFeedbackText: colors.metalhammer.white,
      npsInputColor: colors.metalhammer.black,
      npsInputBackground: colors.metalhammer.white,
      overlay: HEXtoRGBA(colors.metalhammer.black, 0.65),
      pollMultipleChoiceLabelBackground: colors.metalhammer.lightGrey,
      pollOptionResultBarBackground: colors.metalhammer.lightGrey,
      pollOptionResultBarBackgroundModeResult: colors.metalhammer.secondaryRed,
      pollOptionResultBarBackgroundModeResultVote:
        colors.metalhammer.secondaryRed,
      pollOptionResultBarModeResult: colors.metalhammer.primaryRed,
      pollOptionResultBarModeResultVote: colors.metalhammer.primaryRed,
      pollAndQuizOptionBackground: colors.metalhammer.white,
      pollAndQuizOptionBackgroundModeResult: colors.metalhammer.white,
      primary: colors.metalhammer.black,
      primary100: HEXtoRGBA(colors.metalhammer.black, 0.6),
      quizOptionResultBarBackground: colors.metalhammer.lightGrey,
      quizOptionResultBarBackgroundCorrect: HEXtoRGBA(
        colors.metalhammer.green,
        0.4
      ),
      quizOptionResultBarBackgroundWrong: HEXtoRGBA(
        colors.metalhammer.primaryRed,
        0.4
      ),
      resultBarText: colors.metalhammer.black,
      resultGlass: colors.metalhammer.primaryRed,
      resultGlassBackground: colors.metalhammer.secondaryRed,
      resultGlassBorder: colors.metalhammer.white,
      resultGlassText: colors.metalhammer.white,
      secondary: colors.metalhammer.primaryRed,
      secondary100: HEXtoRGBA(colors.metalhammer.primaryRed, 0.6),
      sliderBackground: colors.metalhammer.black,
      success: colors.metalhammer.green,
      tertiary: colors.metalhammer.primaryRed,
      tertiary100: colors.metalhammer.primaryRed,
      thumbsBackground: "none",
      thumbsButton: colors.metalhammer.white,
      thumbsButtonBackground: colors.metalhammer.black,
      thumbsButtonHover: colors.metalhammer.primaryRed,
      thumbsCount: colors.metalhammer.white,
      thumbsCountHidden: colors.metalhammer.black,
      thumbsHeaderBackground: colors.metalhammer.primaryRed,
      votingHorizontalLine: colors.metalhammer.black,
      votingOptionColor: colors.metalhammer.black,
      votingOptionHeaderText: colors.metalhammer.black,
      votingOptionText: colors.metalhammer.white,
      votingOptionTextHover: colors.metalhammer.primaryRed,
      votingPercentBubbleColor: HEXtoRGBA(colors.metalhammer.primaryRed, 0.8),
      votingPercentBubbleText: colors.metalhammer.black,
      votingVoteColor: colors.metalhammer.primaryRed,
      votingVoteText: colors.metalhammer.black,
      inputColor: colors.metalhammer.black400,
    },
    spacing: defaultSpacing,
    borders: {
      ...defaultBorders,
      resultGlass: "0",
      answerTile: "0",
      button: "0",
    },
    others: otherDefaults,
  },
};

export default Variants;
